export const CONFs = {
    multipart: {
        "Content-Type": "multipart/form-data",
    },
    application: {
        "Content-Type":"application/json"
    },
};

export const APPKEYs = {
    kakao: "9923f76f3766a280c1b588678be6082a",
    kakaomap:"47f50834ee07f76133420711a13ec99f",
    local: "OnmomtouchEdu!",
}

export const URLs = {
    basic: process.env.VUE_APP_API,
    display: process.env.VUE_APP_API + "/v1/auth/display",
    displayBoard: process.env.VUE_APP_API + '/v1/auth/board-display',
    displaySns: process.env.VUE_APP_API + "/v1/auth/display-sns",
    personalList: '/v1/personal-list',
    personal: '/v1/personal',
    auth: '/v1/auth',
    customer: '/v1/customers',
    excel: '/v1/sync/excel',
    senior: '/v1/senior',
    recipients: '/v1/recipients',
    staffs: '/v1/staffs',
    members: '/v1/members',
    rfid: '/v1/rfid',
    sns: '/v1/sns-posts',
    settings: '/v1/settings',
    permission: '/v1/permission',
    mypage: '/v1/mypage',
    kakao: '/v2/local',
    pushs: '/v1/pushs',
    calendars: '/v1/calendars',
    dashboard: '/v1/dashboard',
    ltcareb: '/v1/ltcareb-eval',
    management: '/v1/management',
    approval: '/v1/approval',
    payment: '/v1/payment',
    diary: '/v1/diary',
    sync: '/v1/sync',
    budget: {
        prevYearCarryover: '/v1/budget/prev-year-carryover',
    },
}



// WEBPACK FOOTER //
// ./src/config/index.js